import React, { Component } from "react";
// import React, { Component, lazy, Suspense} from 'react';
import {  Route, Switch } from "react-router-dom";
import PreEnrolled from "./Enrolleds/PreEnrolled";
import Workshop from "./Enrolleds/Workshop";

class Routes extends Component {

    render() {
        var array_routes = [
            {
                route: "/",
                component: PreEnrolled,
            },
            {
                route: "/:career_id",
                component: PreEnrolled,
            },
            {
                route: "/:career_id/:career_name",
                component: PreEnrolled,
            },
            {
                route: '/congreso/talleres/:id',
                component: Workshop
            }
        ];
        return (
          <div>
              {/*<Suspense fallback={<div style={{display: 'flex',alignItems:'center',justifyContent:'center', flexDirection: 'column'}}><CircularProgress /></div>}>
               */}
              <Switch>
                  {array_routes.map((data)=>{
                    return (
                      <Route exact path={data.route} component={data.component} />
                    );
                  })}

              </Switch>
              {/*</Suspense>*/}
          </div>
        );
    }
}
export default Routes;
